/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 15:48
 * Desc: 季度配比变化异常
 */

import styles from './common.scss';
import React from 'react';
import { Spin } from 'antd';
import { isEmpty } from '../../../../../utils/util';
import BBDLineBar from '../../../../common/echarts/BBDLineBar';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class QuarterMatchChange extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            barOption: {}
        };
    }

    formatResponse = (data) => {
        let category = [],
            barData = [
                { name: '第一季度', data: [], barGap: 0 },
                { name: '第二季度', data: [] },
                { name: '第三季度', data: [] },
                { name: '第四季度', data: [] }
            ];
        data = data || {};
        if (isEmpty(data)) {
            return {};
        }

        data.forEach(d => {
            category.push(d.reportYear);
            barData[0].data.push(d.firquarInco);
            barData[1].data.push(d.secquarInco);
            barData[2].data.push(d.thiquarInco);
            barData[3].data.push(d.fouquarInco);
        });

        return {
            barOption: {
                color: ['#2365C4', '#F99248', '#FACD89', '#A9DFFB'],
                grid: {
                    top: 25
                },
                legend: {
                    left: 'center',
                    itemWidth: 10,
                    itemHeight: 10
                },
                barMaxWidth: 25,
                category,
                barData
            }
        };
    };

    render() {
        const { loading, barOption } = this.state;

        return (
            <div >
                <div className="sub-title">近年季度营收占比情况</div>
                <div className={styles.quarterMatchChart}>
                    {
                        loading ?
                            <Spin /> :
                            <BBDLineBar option={barOption}/>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/QuarterMatchChange.jsx